module.exports = __webpack_public_path__ + "static/media/logo.cfdbeb3c.png";